namespace TabAurous.Production {
    export interface MFGTransactionForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        DepartmentId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        ItemDetails: MFGTransactionItemsEditor;
    }

    export class MFGTransactionForm extends Serenity.PrefixedContext {
        static formKey = 'Production.MFGTransaction';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MFGTransactionForm.init)  {
                MFGTransactionForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = MFGTransactionItemsEditor;

                Q.initFormType(MFGTransactionForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherTypeId', w2,
                    'VoucherNo', w0,
                    'DepartmentId', w3,
                    'UserId', w3,
                    'EmployeeId', w2,
                    'RefVoucherId', w2,
                    'RefTransId', w0,
                    'ItemDetails', w4
                ]);
            }
        }
    }
}
